import { Analytics } from './analytics';

export class SharePopoverTracking {

    public static track() {
        $(".data-social-media-tracking.twitter").on("click", () => {
            Analytics.sendRawEvent({
                "event": "share_content",
                "interaction": {
                    "social_network": "twitter"
                }
            });
        });

        $(".data-social-media-tracking.facebook").on("click", () => {
            Analytics.sendRawEvent({
                "event": "share_content",
                "interaction": {
                    "social_network": "facebook"
                }
            });
        });

        $(".data-social-media-tracking.linkedin").on("click", () => {
            Analytics.sendRawEvent({
                "event": "share_content",
                "interaction": {
                    "social_network": "linkedin"
                }
            });
        });
    }
}
